import { UserAuthority } from '-/typings/index.d'

export function getAuthority(value?: UserAuthority): string[] {
  let authority
  const authorityString = typeof value === 'undefined' ? localStorage.getItem('authority') : value
  // authorityString could be admin, "admin", ["admin"]
  if (!authorityString) return ['guest']

  try {
    authority = JSON.parse(authorityString)
  } catch (e) {
    authority = authorityString
  }

  if (typeof authority === 'string') {
    return [authority]
  }

  return authority
}

// TODO: 用 Authority 替换 authority 参数的类型
export function setAuthority(authority: string[] | string): void {
  const proAuthority = typeof authority === 'string' ? [authority] : authority

  localStorage.setItem('authority', JSON.stringify(proAuthority))
}
